module.exports = __webpack_public_path__ + "static/img/Australia.bedb614.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/landmark/Australia.png
// module id = Nu5K
// module chunks = 1